const pl = {
  'INTEGRATIONS.ServiceNow.discovery.CONNECTIONNAME.title':
    'Nazwa źródła wykrywania',
  'INTEGRATIONS.ServiceNow.discovery.USERNAME.title':
    'Identyfikator użytkownika',
  'INTEGRATIONS.ServiceNow.discovery.INSTANCENAME.title':
    'Adres URL usługi ServiceNow',
  'INTEGRATIONS.ServiceNow.discovery.PASSWORD.title': 'Hasło',
  'INTEGRATIONS.SERVICENOW.URL.VALIDATION_ERROR1': 'Nieprawidłowy adres URL',
  'INTEGRATIONS.LABEL.DISCOVERY_FREQUENCY': 'Częstotliwość wykrywania',
  'INTEGRATIONS.DESCRIPTION.KBA_PROMPT':
    'Poproś użytkowników o odpowiedź na pytania weryfikacyjne oparte na wiedzy (KBA).',
  'INTEGRATIONS.DISCOVERY.DESCRIPTION':
    'Odkryj swoje aplikacje i obciążenia za pomocą jednego z tych popularnych źródeł wykrywania. Uzyskasz dostęp do takich korzyści, jak automatycznie wypełnione dane, priorytetowe rekomendacje oraz pełny wgląd w status dołączania.',
  'INTEGRATIONS.DISCOVERY.BACK': 'Wstecz',
  'INTEGRATIONS.DISCOVERY.TITLE': 'Skonfiguruj wykrywanie',
  'INTEGRATIONS.DISCOVERY.COMINGSOON': 'Już wkrótce...',
  'INTEGRATIONS.DISCOVERY.LEARNMORE': 'Dowiedz się więcej',
  'INTEGRATIONS.DISCOVERY.CONNECTION.APPLICATION.SETUP.DESCRIPTION':
    'Wprowadź dane uwierzytelniające aplikacji, aby nawiązać połączenie. Po pomyślnym nawiązaniu połączenia będzie można zaimportować dane.',
  'INTEGRATIONS.DISCOVERY.ERROR.HEADING':
    'Wystąpił błąd podczas ładowania strony.',
  'INTEGRATIONS.DISCOVERY.ERROR.SUBHEADING':
    'Spróbuj odświeżyć stronę lub sprawdź później. Jeśli ten problem będzie się powtarzać, skontaktuj się z administratorem.',
  'INTEGRATIONS.DISCOVERY.ERROR.RELOAD': 'Załaduj ponownie',
  'INTEGRATIONS.ServiceNow.discovery.CONNECTION_SETTINGS.title':
    'Ustawienia połączenia',
  'INTEGRATIONS.ServiceNow.discovery.CI_CLASSES.title': 'Klasy CI***',
  'INTEGRATIONS.ServiceNow.discovery.ATTRIBUTE_MAPPING.title':
    'Mapowanie atrybutów',
  'INTEGRATIONS.Feature.Basic.ServiceNow.discovery.Conn.Title':
    'Szczegóły połączenia',
  'INTEGRATIONS.BUTTON.SAVE': 'Zapisz',
  'INTEGRATIONS.DISCOVERY.SELECT': 'Wybierz',
  'INTEGRATIONS.DISCOVERY.CREATE_NEW_CONNECTION': 'Utwórz nowe połączenie',
  'INTEGRATIONS.DISCOVERY.USE_THIS_CONNECTION': 'Użyj tego połączenia',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED': 'Zapisano usługę ServiceNow!',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED.DESCRIPTION':
    'Twoje połączenie ze źródłem wykrywania ServiceNow zostało pomyślnie przetestowane i zapisane. Zaimportuj dane, aby zakończyć konfigurację wykrywania. Możesz pominąć...',
  'INTEGRATIONS.DISCOVERY.IMPORT': 'Importuj zasoby',
  'INTEGRATIONS.DISCOVERY.SKIP_FOR_NOW': 'Pomiń na razie',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED.INLINE':
    'Po rozpoczęciu importu nie będzie można go anulować',
  'INTEGRATION.DISCOVERY.SETUP.GUIDE_ME': 'Poprowadź mnie',
  'INTEGRATION.DISCOVERY.SELECT_EXISTING': 'Wybierz istniejące połączenie',
  'INTEGRATION.DISCOVERY.CONNECTION.NAME': 'Nazwa połączenia',
  'INTEGRATION.EXISTING.CONNECTION.SUBTEXT':
    'Wykryliśmy następującą liczbę istniejących konfiguracji połączenia: {total, plural, one {1} other {#}}:',
  'INTEGRATIONS.FILEUPLOAD.STARTIMPORT': 'Rozpocznij import',
  'INTEGRATIONS.FILEUPLOAD.IMPORTINGDATA':
    'Importowanie danych z pliku programu Excel. Proszę czekać...',
  'INTEGRATIONS.TRY.AGAIN': 'Spróbuj ponownie',
  'INTEGRATIONS.CLOSE': 'Zamknij',
  'INTEGRATIONS.ERROR.CONNECTION': 'Błąd połączenia. Spróbuj ponownie.',
  'INTEGRATIONS.FILEUPLOAD.SUCCESS':
    'Możesz opuścić tę stronę podczas oczekiwania. Powiadomimy Cię, gdy proces zostanie zakończony.',
  'INTEGRATIONS.FILEUPLOAD.MODAL.TITLE': 'Importuj źródło wykrywania',
  'INTEGRATIONS.FILEUPLOAD.HEADING': 'Importuj swoje źródło wykrywania z pliku',
  'INTEGRATIONS.FILEUPLOAD.DOWNLOAD_SAMPLE': 'Pobierz przykładowy plik',
  'INTEGRATIONS.FILEUPLOAD.INPUT_LABEL': 'Nazwa źródła wykrywania',
  'INTEGRATIONS.FILEUPLOAD.INPUT_PLACEHOLDER': 'Wprowadź nazwę pliku',
  'INTEGRATIONS.FILEUPLOAD.INVALID_NAME':
    'Podaj prawidłową nazwę pliku. Dozwolone są tylko litery, cyfry oraz wybrane symbole.',
  'INTEGRATIONS.FILEUPLOAD.UPLOADING': 'Przesyłanie...',
  'INTEGRATIONS.FILEUPLOAD.CONTINUE': 'Kontynuuj',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.TITLE':
    'Oto pierwsze 10 rekordów z przesłanego pliku w formacie XLSX.',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.MISSING_HEADER':
    'Brak wymaganego nagłówka',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.COLUMN_ERRORS_SUFFIX':
    'Wykryto błędy w kolumnach',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.FIX_ISSUES':
    'Napraw błędy przed rozpoczęciem importu danych.',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.EXCLUDE': 'Wyklucz z importu',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.TITLE':
    'Potwierdzenie dołączania aplikacji',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.DESCRIPTION':
    'Zidentyfikowaliśmy typ aplikacji. Potwierdź, czy jest to właściwy typ aplikacji, którą dołączasz.',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.DEFAULT_APP_DESC':
    'Typ aplikacji, którą dołączasz, to {applicationName}',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.SELECT_DIFFERENT':
    'Nie, wybierz z listy aplikacji',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.CONFIRM':
    'Tak, rozpoczynam dołączanie',
  'INTEGRATIONS.DASHBOARD.HEADER.TITLE': 'Integracje',
  'INTEGRATIONS.DASHBOARD.HEADER.ADD_INTEGRATION': 'Dodaj integrację',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.SEARCH': 'Nie znaleziono wyników dla',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.FILTER': 'Nie',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.FILTER.SUFFIX': 'znaleziono integracji.',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.HIDDEN':
    'Brak dostępnych ukrytych integracji.',
  'INTEGRATIONS.DASHBOARD.APPLICATIONS_DISCOVERED': 'Wykryte aplikacje',
  'INTEGRATIONS.DASHBOARD.OWNER_LABEL': 'Właściciel:',
  'INTEGRATIONS.DASHBOARD.LAST_DISCOVERED': 'Ostatnio wykryto dnia',
  'INTEGRATIONS.DASHBOARD.CONNECTION_FAILED': 'Łączenie nie powiodło się',
  'INTEGRATIONS.DASHBOARD.USERS_HAVE_ACCESS': 'Użytkownicy mają dostęp',
  'INTEGRATIONS.DASHBOARD.CHIP_DISCOVERY_SOURCE': 'Źródło wykrywania',
  'INTEGRATIONS.BUTTON.ENABLE': 'Włącz',
  'INTEGRATIONS.BUTTON.DISABLE': 'Wyłącz',
  'INTEGRATIONS.ENABLING': 'Włączanie',
  'INTEGRATIONS.MODAL_TITLE.DISCOVERY': 'Wykrywanie',
  'INTEGRATIONS.DASHBOARD.REUPLOAD': 'Prześlij ponownie',
  'INTEGRATIONS.DASHBOARD.ONBOARD': 'Dołącz',
  'INTEGRATIONS.DASHBOARD.HIDE': 'Ukryj',
  'INTEGRATIONS.DASHBOARD.UNHIDE': 'Odkryj',
  'INTEGRATIONS.DISCOVERY.TABS_ARIA_LABEL': 'Karty konfiguracji wykrywania',
  'INTEGRATIONS.DISCOVERY.DISCARD_UNSAVED_CHANGES_TITLE':
    'Odrzucić niezapisane zmiany?',
  'INTEGRATIONS.DISCOVERY.DISCARD_UNSAVED_CHANGES_SUBTITLE':
    'Masz niezapisane zmiany. Zmiany zostaną utracone, jeśli będziesz kontynuować.',
  'INTEGRATIONS.BUTTON.DISCARD_CHANGES': 'Odrzuć zmiany',
  'INTEGRATIONS.BUTTON.CANCEL': 'Anuluj',
  'INTEGRATIONS.BUTTON.SAVE_ERROR_TITLE': 'Błąd zapisu',
  'INTEGRATIONS.CMDB_HEADER.BACK_BUTTON_ARIA_LABEL':
    'Wróć do poprzedniej strony',
  'INTEGRATIONS.CMDB_HEADER.IMAGE_ALT': 'Ikona aplikacji',
  'INTEGRATIONS.CMDB_HEADER.RUN_MANUALLY_BUTTON': 'Uruchom ręcznie',
  'INTEGRATIONS.CMDB_HEADER.ALERT.DISABLE_FAILED_TITLE':
    'Wyłączenie nie powiodło się',
  'INTEGRATIONS.CMDB_HEADER.ALERT.ENABLE_FAILED_TITLE':
    'Włączenie nie powiodło się',
  'INTEGRATIONS.CMDB_HEADER.ALERT.DISABLE_SUCCESS_DESCRIPTION':
    'Wyłączono pomyślnie.',
  'INTEGRATIONS.CMDB_HEADER.ALERT.ENABLE_SUCCESS_DESCRIPTION':
    'Włączono pomyślnie.',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.JOBCONFLICT':
    'Obecnie trwa inny import.',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.JOBCONFLICT.SUBHEADING':
    'Zasoby są obecnie importowane w innym procesie. Spróbuj ponownie później.',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.IMPORTFAILED':
    'Importowanie nie powiodło się',
  'INTEGRATIONS.DISCOVERY.IMPORTINGASSETS':
    'Importowanie zasobów z usługi ServiceNow',
  'INTEGRATIONS.DISCOVERY.IMPORTINGASSETS.MESSAGE':
    'Możesz opuścić tę stronę podczas oczekiwania. Powiadomimy Cię, gdy proces zostanie zakończony.',
  'INTEGRATIONS.ATTRIBUTE_MAPPINGS.BUTTON.ADD_ROW_ARIA_LABEL':
    'Dodaj nowy wiersz mapowania atrybutu',
  'INTEGRATIONS.ATTRIBUTE_MAPPINGS.BUTTON.ADD_ATTRIBUTE': 'Dodaj atrybut',
  'INTEGRATIONS.ATTRIBUTE_ROW.EMPTY_PLACEHOLDER': '(Puste)',
  'INTEGRATIONS.ATTRIBUTE_ROW.DELETE_ARIA_LABEL': 'Usuń to mapowanie',
  'INTEGRATIONS.ATTRIBUTE_ROW.HEADER.SERVICENOW_FIELD': 'Pole ServiceNow',
  'INTEGRATIONS.ATTRIBUTE_ROW.HEADER.SAVIYNT_FIELD': 'Pole Saviynt',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.SEARCH_SERVICENOW':
    'Wyszukaj atrybut usługi ServiceNow',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.SEARCH_SAVIYNT': 'Wyszukaj atrybut Saviynt',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.CUSTOM_SUFFIX': '(Niestandardowe)',
  'INTEGRATIONS.ERROR.SAVE_FAILED': 'Nie udało się zapisać',
  'INTEGRATIONS.SCHEDULING.ARIA_LABEL': 'Konfiguracja harmonogramu',
  'INTEGRATIONS.SCHEDULING.REPEATS_AT': 'o godz. {timeLabel} (UTC).',
  'INTEGRATIONS.SCHEDULING.REPEAT_ON_TITLE': 'Powtórz w dniu',
  'INTEGRATIONS.SCHEDULING.REPEAT_ON_DAYS_GROUP': 'Powtarzaj w dni',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.LABEL.REPEAT_EVERY': 'Powtarzaj co',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.PLACEHOLDER.ENTER_INTERVAL':
    'Wprowadź interwał',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.ARIA_LABEL.REPEAT_INTERVAL':
    'Interwał powtarzania w dniach, tygodniach lub miesiącach',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.DAY': 'Dzień',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.WEEK': 'Tydzień/tygodnie',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.MONTH': 'Miesiąc',
  'INTEGRATIONS.DAYS.SUN': 'Nie',
  'INTEGRATIONS.DAYS.MON': 'Pon',
  'INTEGRATIONS.DAYS.TUE': 'Wto',
  'INTEGRATIONS.DAYS.WED': 'Śro',
  'INTEGRATIONS.DAYS.THU': 'Czw',
  'INTEGRATIONS.DAYS.FRI': 'Pią',
  'INTEGRATIONS.DAYS.SAT': 'Sob',
  'INTEGRATIONS.BUTTON.DISABLING': 'Wyłączanie',
  'INTEGRATIONS.BUTTON.SAVED': 'Zapisano',
  'INTEGRATIONS.BUTTON.SAVING': 'Zapisywanie',
  'INTEGRATIONS.DISABLE_MODAL.ALERT_TITLE': 'Czy na pewno chcesz wyłączyć ',
  'INTEGRATIONS.DISABLE_MODAL.ALERT_SUBTITLE':
    'Wyłączenie źródła wykrywania spowoduje zatrzymanie importu zasobów i uniemożliwi jego dalszą konfigurację.',
  'INTEGRATIONS.DISCOVERY.HERE': 'tutaj',
  'INTEGRATIONS.DISCOVERY.EXISTING.CONNECTION.FAILED':
    'Źródło wykrywania zostało pomyślnie utworzone, ale połączenie z usługą ServiceNow nie powiodło się. Aby rozpocząć importowanie zasobów, zaktualizuj dane połączenia na stronie konfiguracji źródła wykrywania ',
};

export default pl;
